import { render, staticRenderFns } from "./Withdraw.vue?vue&type=template&id=2b09a32e&scoped=true"
import script from "./Withdraw.vue?vue&type=script&setup=true&lang=ts"
export * from "./Withdraw.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Withdraw.vue?vue&type=style&index=0&id=2b09a32e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b09a32e",
  null
  
)

export default component.exports